<template>
    <transition name="fade">
        <div class="streamingVideo">

            <!-- Live Video -->
            <div class="vg-video-container">
                <video class="iframeVideo" :src="streamURL()" controls/>
            </div>

            <div class="vg-cross" @click="leaveGallery()"/>        
        </div>  
    </transition>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
    methods:{
        ...mapMutations(['handleGotoSituationTransition']),
        leaveGallery(){
            window.open("https://sales.flux-cms.de/Venjakob-Messe/", "_self");
        },
        streamURL(){
            var userLang = navigator.language || navigator.userLanguage; 
            if(userLang.includes("de"))
                return "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Betriebsführung - Deutsch.mp4"
            return "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Betriebsführung - Englisch.mp4"
        }
    },
}
</script>

<style scoped>
    .streamingVideo{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        background: white;
    }
    .streaming-top-block-wrapper{
        position: absolute;
        display: flex;
        top: 20px;
        left: 20px;
    }
    .iframeVideo{
        margin-top: 40px;
        max-height: 80vh;
        cursor: pointer;
    }
    .vg-video-container{
        position: relative;
        display: inline-block;
        justify-content: center;
        align-items: center;
        width: 70%;
    }
    .vg-cross {
        position: absolute;
        left: 60px;
        top: 40px;
        cursor: pointer;
    }
    .vg-cross:after {
        content: '';
        height: 30px;
        border-left: 4px solid red;
        position: absolute;
        top: 0;
        left: 10px;
        transform: rotate(45deg) ;
    }
    .vg-cross:before {
        content: '';
        height: 30px;
        border-left: 4px solid red;
        position: absolute;
        top: 0;
        left: 10px;
        transform: rotate(-45deg);
    }
    .meetingBtn{
        position: absolute;
        bottom: 60px;
        right: 30px;

        padding: 10px;

        background-color:#1E717C ;
        color: white;
        border: none;

        cursor: pointer;
        width: 210px;
        font-size: 16px;
    }
</style>